export default "__VITE_PUBLIC_ASSET__0124078f__"